import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../../services";
import { decryptMessage } from "../../services/encryption.decryption";
// import toaster from "../../utilities/toaster";

export const getInventoryHandoverData = createAsyncThunk(
  "InventoryHandover/inventory handover",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

type SliceState = {
  loading: boolean;
  inventoryHandoverRequestData: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  inventoryHandoverRequestData: [],
};

const inventoryHandoverRequestSlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setInventoryHandoverData(state, action) {
      state.inventoryHandoverRequestData = action.payload;
    },
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getInventoryHandoverData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInventoryHandoverData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.inventoryHandoverRequestData = data?.data[0].list;
      } else {
        // toaster("error", data.message);
        state.inventoryHandoverRequestData = [];
      }
    });
    builder.addCase(getInventoryHandoverData.rejected, (state) => {
      state.loading = true;
    });
  },
});
export const { setInventoryHandoverData } =
  inventoryHandoverRequestSlice.actions;

export default inventoryHandoverRequestSlice;
